import React from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Grid,
  Dialog,
  TextField,
  Container,
  CardContent,
  IconButton,
  DialogTitle,
  Divider,
  Card
} from '@mui/material'
import { ActionButton } from '../../../utils/ui_utils'
import { Close } from '@mui/icons-material'
import { Formik } from 'formik'
import * as Yup from 'yup'

const AppFlavourModal = ({
  visible,
  title,
  initialValues,
  okText,
  onSubmit,
  onClose,
  appFlavourData
}) => {
  const validationSchema = Yup.object().shape({
    flavor_name: Yup.string().required('Required'),
    app_package: Yup.string().required('Required')
  })

  const handleSubmit = async (values) => {
    onSubmit(values)
  }

  if (initialValues == undefined) {
    initialValues = {
      flavor_name: '',
      app_package: ''
    }
  }

  return (
    <>
      <Dialog
        maxWidth="xs"
        fullWidth
        open={visible}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <>
            {title}
            <IconButton
              component="span"
              size="small"
              sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
              onClick={onClose}
              variant="contained"
            >
              <Close />
            </IconButton>
          </>
        </DialogTitle>
        <Container sx={{ marginBottom: 5 }}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              touched,
              values,
              status
            }) => (
              <form onSubmit={handleSubmit}>
                <Divider my={2} />
                <Card>
                  <CardContent>
                    <Grid
                      container
                      direction="column"
                      spacing={5}
                      style={{ paddingTop: 1 }}
                    >
                      <Grid item>
                        <TextField
                          size="small"
                          name="flavor_name"
                          label="App Flavor Name"
                          value={values?.flavor_name}
                          error={Boolean(
                            touched?.flavor_name && errors?.flavor_name
                          )}
                          fullWidth
                          helperText={
                            touched?.flavor_name && errors?.flavor_name
                          }
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          size="small"
                          name="app_package"
                          label="Application Package"
                          value={values?.app_package}
                          error={Boolean(
                            touched?.app_package && errors?.app_package
                          )}
                          fullWidth
                          helperText={
                            touched?.app_package && errors?.app_package
                          }
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                          // disabled={initialValues?.app_package ? true : false}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <ActionButton
                      variant="outlined"
                      size="medium"
                      type="submit"
                      mt={8}
                    >
                      {okText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Dialog>
    </>
  )
}

export default AppFlavourModal
